export default "__VITE_ASSET__pN0mxtTL__"